import React from 'react'
import { createRoot } from 'react-dom/client';
import register from './registerServiceWorker'
import App from './App'

register()

const root = createRoot(document.getElementById('app')); // createRoot(container!) if you use TypeScript
root.render(<App tab="home" />);